/**
 * The mechanics bench's mark: an Atwood machine — the bench's signature build,
 * a pulley on a ceiling and two unequal masses on one rope.
 *
 * The same drawing as zitmus's masthead icon (sciencexp-app Base.astro), so the
 * bench looks the same wherever it is offered. The frame is `currentColor`, so
 * it takes the text colour of whatever it sits in; the masses keep their own.
 */
export function MechanicsMark({ size = 26, className }: { size?: number; className?: string }): React.JSX.Element {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M5 2 H19" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M12 2 V4.2" stroke="currentColor" strokeWidth="1.4" />
      <circle cx="12" cy="7.4" r="3.2" fill="rgba(150,160,180,0.35)" stroke="currentColor" strokeWidth="1.5" />
      <path d="M8.8 7.4 V13.2 M15.2 7.4 V16.6" stroke="currentColor" strokeWidth="1.2" />
      <rect x="6.3" y="13.2" width="5" height="5" rx="0.8" fill="#4a78c2" />
      <rect x="12.7" y="16.6" width="5" height="6" rx="0.8" fill="#d0584f" />
    </svg>
  );
}
